export default __webpack_public_path__ + "static/media/logo.ebcf0277.svg";